(function () {
    'use strict';
    /*
     * Copyright (c) 2014-2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * The controller for the login page. Referenced from other apps that have a login page. The
     * example code below shows how to hook up the login controller.
     * @ngdoc controller
     * @name LoginCtrl
     * @memberOf ihh-common-web
     * @example
     * angular.module('someModule').config(
     *
     * ['$routeProvider',
     *
     * function($routeProvider) {
     *     // Other config code, including other routes
     *     $routeProvider.when('/login', {
             controller: 'LoginCtrl',
             templateUrl: 'user/login.tpl.html'
           });
     * }]);
     */
    angular
        .module('ihh-common-web')
        .controller('LoginCtrl', LoginCtrl);

    LoginCtrl.$inject = ['$scope', '$window', '$http', '$location', '$routeParams', '$modal', '$q', '$log', 'LoginSvc', 'MemorySvc', 'UserSvc', 'Idle', 'Utilities', 'RestResources', 'appConfig'];

    function LoginCtrl($scope, $window, $http, $location, $routeParams, $modal, $q, $log, LoginSvc, MemorySvc, UserSvc, Idle, Utilities, RestResources, appConfig) {

        /**
         * Sets up the scope.
         */
        var setupControllerScope = function() {
            Idle.unwatch();
            $scope.credentials = {};
            $scope.storedUsername = MemorySvc.recall(MemorySvc.LOCAL, UserSvc.USERNAME);
            $scope.credentials.username = $scope.storedUsername || '';
            $scope.credentials.password = '';

            if (angular.isDefined($routeParams.username)) {
                $scope.credentials.username = $routeParams.username;
            }
            if (angular.isDefined($routeParams.password)) {
                $scope.credentials.password = $routeParams.password;
            }
        };

        setupControllerScope();

        /**
         * Logs the user into the application.
         *
         * @param {Object} credentials the credentials (username, password) of the user
         */
        $scope.login = function(credentials) {
            var loginModal;

            if ($scope.isPatientApp()) {
                loginModal = $modal.open({
                    templateUrl: 'utilities/patient-login-wait.tpl.html',
                    windowClass: 'patient-login-modal-window'
                });
            }
            else {
                loginModal = $modal.open({
                    templateUrl: 'utilities/ptih-login-wait.tpl.html',
                    controller: 'PtihLoginWaitCtrl',
                    scope: $scope
                });
            }

            LoginSvc.login(credentials, appConfig.loginParams, function() {
                MemorySvc.memorize(MemorySvc.LOCAL, UserSvc.USERNAME, credentials.username);
                $scope.loginError = null;
                $scope.refreshSelf();
                loginModal.close();
                if (angular.isDefined($scope.user.session.sessionType) && $scope.user.session.sessionType === 'restricted') {
                    Utilities.modal('user/change-password.tpl.html', 'ChangePasswordCtrl', {
                        config: function() {
                            return {
                                oldPassword: $scope.credentials.password,
                                context: 'login'
                            };
                        }
                    }, function(passwordChangeRequest) {
                        $scope.busyPromise = $q.defer().promise;
                        var resource = RestResources.getPersonPasswordResource($scope.user.self.id);
                        resource.update({}, passwordChangeRequest, function() {
                            $scope.busyPromise = null;
                            var waitModal = Utilities.modalWait('Password changed.', 'Close', 'Password Change Successful');
                            waitModal.result.then(function() {
                                credentials.password = passwordChangeRequest.newPassword;
                                $scope.login(credentials);
                            });
                        }, function(err) {
                            $scope.busyPromise = null;
                            RestResources.reportRestError('Could not update password', err);
                        });
                    }, function() {
                        LoginSvc.logout($scope.user.session);
                    });
                }
                else {
                    $location.path(appConfig.afterLoginPath);
                    $location.search('username', null);
                    $location.search('password', null);
                }
            }, function(error) {
                loginModal.close();
                $scope.loginError = error;

                if ($scope.loginError.status === 401) {
                    Utilities.modalWait('Please verify your email and password and try signing in again.', 'Close', 'Unable to sign in');
                }
                else if ($scope.loginError.status === 0) {
                    Utilities.modalWait('Unable to establish connection to server. Please try again later.', 'Close', 'Unable to sign in');
                }
                else {
                    Utilities.modalWait('Unable to sign in due to the following error: ' + $scope.loginError.status + ' - ' + $scope.loginError.statusText, 'Close', 'Unable to sign in');
                }
            });
        };

        /**
         * Opens the Reset Password modal.
         */
        $scope.resetPassword = function() {
            Utilities.modal('user/reset-password.tpl.html', 'ResetPasswordCtrl', {
                emailAddress: function() {
                    return $scope.credentials.username;
                },
                app: function() {
                    return appConfig.app;
                }
            });
        };

        /**
         * Attempts to log the user in if the route params have a username and password.
         */
        var attemptLoginWithRoute = function() {
            if (angular.isDefined($routeParams.username) && angular.isDefined($routeParams.password)) {
                $scope.login($scope.credentials);
            }
        };

        /**
         * Checks for a newer version of the UI by asking the server for a version.
         * If the remote version does not match the local version, the window reloads.
         */
        var checkForNewerVersion = function() {
            $http.get('/version.json').success(function(data) {
                var localVersion = $scope.version;
                var remoteVersion = data.version;

                if (remoteVersion === null) {
                    $log.warn('version.json is malformed!');
                }
                else if (localVersion !== remoteVersion) {
                    $window.location.reload(true);
                }
            }).error(function() {
                $log.warn('version.json is missing!');
            });
        };

        /**
         * Attaches to the windows focus event to check for a new version.
         */
        var attachFocusEventToCheckVersion = function() {
            $window.onfocus = function() {
                checkForNewerVersion();
            };
                // remove the event when we leave the login page
            $scope.$on('$destroy', function() {
                $window.onfocus = angular.noop();
            });
        };

        /**
         * Runs any functions that should be called at the end of the controller initialization.
         */
        var runOnCtrlInit = function() {
            attachFocusEventToCheckVersion();
            checkForNewerVersion();

            if ($scope.allowed) { //inherited from mainCtrl
                attemptLoginWithRoute();
            }
        };

        runOnCtrlInit();
    }
})();
